import {Component, model, ModelSignal} from '@angular/core';
import {
  CSV_EXPORT_ACTION,
  DELETE_ACTION,
  ITableAction,
  TableControlComponent,
  TableControlModule
} from 'frontier';
import AppControlGuids from '../../../api/ControlGuids';

@Component({
  selector: 'app-vehicle',
  standalone: true,
  imports: [TableControlModule],
  templateUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.html',
  styleUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.scss'
})
export class VehicleComponent extends TableControlComponent {
  override GUID: string = AppControlGuids.TVehicleTableView;
  override actions: ModelSignal<ITableAction[]> = model<ITableAction[]>([
    DELETE_ACTION,
    CSV_EXPORT_ACTION,
  ]);
}
